import { LabMDM } from "./lab";

export class ArrayProject {
    _id: string;
    sender: string;
    projectID: string;
    workflow: string;
    announcedSamples: boolean;
    announcementFile: string;
    beadChipProductID: string;
    duplicate: boolean;
    active: boolean;
    lab: LabMDM;
}